<template>
  <v-card-text class="pa-0">
    <TituloPagina :titulo="tituloDaPagina" />
    <v-card-text
      class="pa-0 mt-3 pb-md-9 primary--text"
      data-cy="texto_da_pagina"
      v-html="textoDaPagina"
    />

    <v-card-title
      class="pa-0 mt-7 mb-4 primary--text justify-center font-weight-bold text-uppercase subtitle-2"
      data-cy="dados_da_compra"
    >
      Dados da Compra
    </v-card-title>
    <v-row
      no-gutters
      class="flex-column pb-12"
    >
      <v-col class="mb-3" data-cy="vendedor_nome">
        Vendedor:
        <strong class="grey--text text--darken-2">
          {{ dadosCompra.vendedor }}
        </strong>
      </v-col>
      <v-col
        :class="{'mb-3': !isOrderBump, 'mb-8': isOrderBump}"
        style="word-break: break-word;"
        data-cy="nome_produto"
      >
        Produto: <strong class="grey--text text--darken-2">
          {{ dadosCompra.produto }}
        </strong>
      </v-col>
      <v-col
        :class="{'mb-3': !isOrderBump, 'mb-8': isOrderBump}"
        style="word-break: break-word;"
        data-cy="produto_plano"
      >
        Plano: <strong class="grey--text text--darken-2">
          {{ dadosCompra.plano }}
        </strong>
      </v-col>
      <v-col :class="{'mb-3': !isOrderBump, 'mb-8': isOrderBump}" data-cy="valor_total">
        <span v-if="isOrderBump">Valor total da compra:</span>
        <span v-else>Valor</span>
        <strong class="grey--text text--darken-2">
          {{ dadosCompra.valor | moeda(dadosCompra.currency_symbol) }}
        </strong>
      </v-col>
      <v-col v-for="(produto, index) in dadosCompra.produtos_order_bump" :key="`produto-${index}`">
        <li style="word-break: break-word;">
          {{ produto.name }}: <strong class="grey--text text--darken-2">
            {{ produto.total | moeda(dadosCompra.currency_symbol) }}
          </strong>
        </li>
      </v-col>
      <v-col :class="{'mt-16': isOrderBump}" class="mb-3" data-cy="dia_da_compra">
        Data <strong class="grey--text text--darken-2">
          {{ dadosCompra.data | dataFormatada('numeric', 'numeric') }}
        </strong>
      </v-col>

      <v-alert
        v-if="cartaoCredito"
        dark
        dense
        color="info"
        class="mt-1 mb-0"
        data-cy="informacoes_cartao"
      >
        A compra foi realizada por meio do(s)
        <strong>cartão(ões) de crédito</strong>
        (final do(s) cartão(ões): {{ stringCartoes }}). Caso o reembolso seja concedido,
        <strong>
          o valor será estornado em seu(s) cartão(ões).
        </strong>
      </v-alert>

      <v-alert
        v-if="dadosCompra.is_pix || dadosCompra.is_paypal"
        dark
        dense
        color="info"
        class="mt-1 mb-0"
        data-cy="informacoes_pix"
      >
        Compra realizada via <strong>{{ isTextPixPaypal }}</strong>. Caso o reembolso seja concedido,
        <strong>o valor será estornado para a mesma conta</strong>.
      </v-alert>
    </v-row>
  </v-card-text>
</template>

<script>

import { mapGetters } from 'vuex';
import TituloPagina from '@/components/TituloPagina.vue';

export default {
  name: 'PassoDadosCompra',

  components: {
    TituloPagina,
  },

  data() {
    return {
      tituloDaPagina: 'Você quer solicitar o reembolso da sua compra?',
      textoDaPagina: 'Siga os próximos passos para confirmar a sua solicitação.'
        + ' Após este procedimento, ela será enviada para o vendedor responsável e entrará em processo de análise.',
    };
  },

  computed: {
    ...mapGetters(['dadosCompra']),

    stringCartoes() {
      const numerosCartoes = this.dadosCompra.cardNumber.map(numCartao => numCartao.card_number);

      return numerosCartoes.join(' / ');
    },

    cartaoCredito() {
      return this.dadosCompra.cartaoCredito && !this.dadosCompra.is_online_debt;
    },

    isOrderBump() {
      return this.dadosCompra.total_order_bump_items > 0;
    },

    isTextPixPaypal() {
      return this.dadosCompra.is_pix ? 'Pix' : 'PayPal';
    },
  },
};
</script>
